<template>
  <div>
    <div
      class="row"
      style="height:300px;">
      <div
        class="col-md-6 text-center d-none d-md-block"
        :style="background">
      </div>
      <div class="col-md-6 col-12 p-5 bg-success text-white position-relative">
        <div class="centered">
          <h2 style="font-weight: 400;">WHETHER YOU ARE A DEALER OR A SUPPLIER</h2>
          <p>We are a growth-oriented leader dedicated to providing a value-added integral link between our suppliers and our customers. This will be accomplished through our core values: Commitment, Integrity, and Reliability</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        background:{
          backgroundImage: `url(${require('../../../../../assets/images/lan/advantage/handShake.jpg')})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }
      }
    }
  }
</script>

<style scoped>
  .centered{
    position: absolute;
    top: 50%;
    padding:10px;
    width: 85%;
    transform: translateY(-50%);
  }
</style>